import React from 'react';
import classNames from 'classnames';
import Slider from 'react-slick';
import { ResponsiveImage } from '../../../components';
import {
  BookingChevronLeftIcon,
  BookingChevronRightIcon,
  bookingGalleryArrowProps,
  bookingLucideClassName,
} from '../../../components/OrderPanel/BookingPageIcons';
import merchatLogo from '../../../assets/merchatLogo.png';
import customerLogo from '../../../assets/customerLogo.png';
import css from './ListingGallery.module.css';

const GalleryArrow = ({ className, style, onClick, direction }) => {
  const Icon = direction === 'prev' ? BookingChevronLeftIcon : BookingChevronRightIcon;
  return (
    <button
      type="button"
      className={classNames(className, css.galleryArrow, bookingLucideClassName)}
      style={style}
      onClick={onClick}
      aria-label={direction === 'prev' ? 'Previous photo' : 'Next photo'}
    >
      <Icon {...bookingGalleryArrowProps} />
    </button>
  );
};

function ListingGallery(props) {
  const { listing, variantPrefix, userType } = props;
  const images = listing?.images || [];
  const hasMultiple = images.length > 1;

  const settings = {
    dots: hasMultiple,
    arrows: hasMultiple,
    speed: 500,
    lazyLoad: true,
    infinite: hasMultiple,
    centerMode: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    prevArrow: <GalleryArrow direction="prev" />,
    nextArrow: <GalleryArrow direction="next" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: hasMultiple,
          arrows: hasMultiple,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: hasMultiple,
          arrows: hasMultiple,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: hasMultiple,
          arrows: hasMultiple,
        },
      },
    ],
  };

  return (
    <div className={classNames(css.listingGrid, images.length === 3 && css.threeImages)}>
      {images.length === 0 ? (
        <div className={css.galleryImage}>
          {userType === 'provider' ? (
            <ResponsiveImage
              rootClassName={css.avatarImage}
              alt="Gallery"
              localImageSrc={merchatLogo}
              variants="custom-image"
            />
          ) : (
            <ResponsiveImage
              rootClassName={css.avatarImage}
              alt="Gallery"
              localImageSrc={customerLogo}
              variants="custom-image"
            />
          )}
        </div>
      ) : (
        <Slider {...settings}>
          {images.map((item, i) => (
            <div className={css.galleryImage} key={item?.id?.uuid || i}>
              <ResponsiveImage
                rootClassName={css.avatarImage}
                alt="Gallery"
                image={item}
                variants={[variantPrefix, `${variantPrefix}-2x`, 'listing-card-2x']}
              />
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
}

export default ListingGallery;
